<template>
    <div id="v-enterprise-wrap">
        <!-- 顶部栏 -->
        <div class="head">
            <dl>
                <dt>
                    <img class="logo" :src="$config.resource + 'dhl_logo.png'" alt="">
                </dt>
                <!-- 头像信息 -->
                <dd>
                    <div class="portrait">
                        <img class="pic" :src="user.head" alt="">
                    </div>
                    <p>{{user.company_name}}</p>
                    <div class="quit" @click="onQuit">
                        <img class="icon" :src="$config.resource + 'tc.png'" alt="">
                    </div>
                </dd>
            </dl>
        </div>
        <!-- 主要部分 -->
        <div class="main_box">
            <!-- 步骤 -->
            <div class="step">
                <img class="pic_bg" :src="$config.resource + 'db_bjt.png'" alt="">
                <div class="row_box">
                    <div class="row curr">
                        <div class="circle">1</div>
                        <p>选择供应商类型</p>
                    </div>
                    <div class="wire white"></div>
                    <div class="row curr">
                        <div class="circle">2</div>
                        <p>企业概况</p>
                    </div>
                    <div class="wire"></div>
                    <div class="row">
                        <div class="circle">3</div>
                        <p>工厂概况</p>
                    </div>
                    <div class="wire"></div>
                    <div class="row">
                        <div class="circle">4</div>
                        <p>产品概况</p>
                    </div>
                    <div class="wire"></div>
                    <div class="row">
                        <div class="circle">5</div>
                        <p>提交</p>
                    </div>
                </div>
            </div>
            <!-- 基础信息 -->
            <div class="alike alike_one">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>基础信息</p>
                </div>
                <ul>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">企业名称（全称）及签章：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="name" placeholder="需与营业执照保持一致" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">统一社会信用代码：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="credit_code" placeholder="需与营业执照保持一致" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">成立年份：</div>
                        </div>
                        <!-- <div class="inp_unit">
                            <input class="inp" type="text" v-model="year" />
                        </div> -->
                        <el-date-picker
                            v-model="establish"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="需与营业执照保持一致">
                        </el-date-picker>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">法人代表：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="delegate" placeholder="需与营业执照保持一致" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">法人代表职务：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="post" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">法人联系电话：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="phone" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">业务对接人：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="abutment" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">业务对接人职务：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="job" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">业务对接人联系电话：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="telephone" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">业务对接人E-mail：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="gmail" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">经营范围：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="run" placeholder="需与营业执照保持一致" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">行业类别：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="trade" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">企业网址：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="url" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">注册地址：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="address" placeholder="需与营业执照保持一致" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">通信地址：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="site" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">注册资本：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="principal" placeholder="需与营业执照保持一致" />
                            <div class="unit">万元</div>
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">资产总值：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="total" />
                            <div class="unit">万元</div>
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">上年度销售额：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="saleroom" />
                            <div class="unit">万元</div>
                        </div>
                    </li>
                </ul>
            </div>
            <!-- 基础信息2 -->
            <div class="alike">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>基础信息2</p>
                </div>
                <dl>
                    <dt>
                        <p>*</p>
                        <div class="short">
                            <em>纳税人类别：</em>
                        </div>
                    </dt>
                    <dd>
                        <div class="unify" :class="{curr:ratepaying == 1}" @click="onRatepaying(1)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="ratepaying!=1" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="ratepaying==1" :src="$config.resource + 'xz.png'" alt="">
                            <p>小规模纳税</p>
                        </div>
                        <div class="unify" :class="{curr:ratepaying == 2}" @click="onRatepaying(2)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="ratepaying!=2" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="ratepaying==2" :src="$config.resource + 'xz.png'" alt="">
                            <p>一般纳税人</p>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        <p>*</p>
                        <div class="short">
                            <em>税</em>
                            <div class="flex-1"></div>
                            <em>率：</em>
                        </div> 
                    </dt>
                    <dd>
                        <div class="unify" :class="{curr:taxRate == 1}" @click="onTaxRate(1)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="taxRate!=1" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="taxRate==1" :src="$config.resource + 'xz.png'" alt="">
                            <p>13%</p>
                        </div>
                        <div class="unify" :class="{curr:taxRate == 2}" @click="onTaxRate(2)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="taxRate!=2" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="taxRate==2" :src="$config.resource + 'xz.png'" alt="">
                            <p>9%</p>
                        </div>
                        <div class="unify" :class="{curr:taxRate == 3}" @click="onTaxRate(3)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="taxRate!=3" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="taxRate==3" :src="$config.resource + 'xz.png'" alt="">
                            <p>6%</p>
                        </div>
                        <div class="unify" :class="{curr:taxRate == 4}" @click="onTaxRate(4)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="taxRate!=4" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="taxRate==4" :src="$config.resource + 'xz.png'" alt="">
                            <p>5%</p>
                        </div>
                        <div class="unify" :class="{curr:taxRate == 5}" @click="onTaxRate(5)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="taxRate!=5" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="taxRate==5" :src="$config.resource + 'xz.png'" alt="">
                            <p>3%</p>
                        </div>
                        <div class="unify" :class="{curr:taxRate == 6}" @click="onTaxRate(6)">
                            <!-- 未选中 -->
                            <img class="icon"  v-if="taxRate!=6" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="taxRate==6" :src="$config.resource + 'xz.png'" alt="">
                            <p>1%</p>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt>
                       <p>*</p>
                        <div class="short">
                            <em>结</em>
                            <div class="flex-1"></div>
                            <em>算</em>
                            <div class="flex-1"></div>
                            <em>方</em>
                            <div class="flex-1"></div>
                            <em>式：</em>
                        </div>
                    </dt>
                    <dd>
                        <div class="unify" :class="{curr:balance == 1}" @click="onBalance(1)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="balance!=1" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="balance==1" :src="$config.resource + 'xz.png'" alt="">
                            <p>当月结</p>
                        </div>
                        <div class="unify" :class="{curr:balance == 2}" @click="onBalance(2)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="balance!=2" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="balance==2" :src="$config.resource + 'xz.png'" alt="">
                            <p>月结30天</p>
                        </div>
                        <div class="unify" :class="{curr:balance == 3}" @click="onBalance(3)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="balance!=3" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="balance==3" :src="$config.resource + 'xz.png'" alt="">
                            <p>月结60天</p>
                        </div>
                        <div class="unify" :class="{curr:balance == 4}" @click="onBalance(4)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="balance!=4" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="balance==4" :src="$config.resource + 'xz.png'" alt="">
                            <p>其它</p>
                            <div class="closing">
                                <input v-if="balance==4" class="inp" type="text" v-model="closing" ref="closing" />
                            </div>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt>
                       <p>*</p>
                        <div class="short">
                            <em>收</em>
                            <div class="flex-1"></div>
                            <em>付</em>
                            <div class="flex-1"></div>
                            <em>方</em>
                            <div class="flex-1"></div>
                            <em>式：</em>
                        </div>
                    </dt>
                    <dd>
                        <div class="unify" :class="{curr:receive == 1}" @click="onReceive(1)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="receive!=1" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="receive==1" :src="$config.resource + 'xz.png'" alt="">
                            <p>银行汇款</p>
                        </div>
                        <div class="unify" :class="{curr:receive == 2}" @click="onReceive(2)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="receive!=2" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="receive==2" :src="$config.resource + 'xz.png'" alt="">
                            <p>银行承兑</p>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt>
                       <p>*</p>
                        <div class="short">
                            <em>企</em>
                            <div class="flex-1"></div>
                            <em>业</em>
                            <div class="flex-1"></div>
                            <em>性</em>
                            <div class="flex-1"></div>
                            <em>质：</em>
                        </div>
                    </dt>
                    <dd>
                        <div class="unify" :class="{curr:firm == 1}" @click="onFirm(1)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="firm!=1" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="firm==1" :src="$config.resource + 'xz.png'" alt="">
                            <p>生产企业</p>
                        </div>
                        <div class="unify" :class="{curr:firm == 2}" @click="onFirm(2)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="firm!=2" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="firm==2" :src="$config.resource + 'xz.png'" alt="">
                            <p>贸易公司</p>
                        </div>
                        <div class="unify" :class="{curr:firm == 3}" @click="onFirm(3)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="firm!=3" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="firm==3" :src="$config.resource + 'xz.png'" alt="">
                            <p>设计研发公司</p>
                        </div>
                        <div class="unify" :class="{curr:firm == 4}" @click="onFirm(4)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="firm!=4" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="firm==4" :src="$config.resource + 'xz.png'" alt="">
                            <p>采购中心</p>
                        </div>
                        <div class="unify" :class="{curr:firm == 5}" @click="onFirm(5)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="firm!=5" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="firm==5" :src="$config.resource + 'xz.png'" alt="">
                            <p>平台中心</p>
                        </div>
                        <div class="unify" :class="{curr:firm == 6}" @click="onFirm(6)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="firm!=6" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="firm==6" :src="$config.resource + 'xz.png'" alt="">
                            <p>服务机构</p>
                        </div>
                        <div class="unify" :class="{curr:firm == 7}" @click="onFirm(7)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="firm!=7" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="firm==7" :src="$config.resource + 'xz.png'" alt="">
                            <p>进出口商</p>
                        </div>
                        <div class="unify" :class="{curr:firm == 8}" @click="onFirm(8)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="firm!=8" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="firm==8" :src="$config.resource + 'xz.png'" alt="">
                            <p>其它</p>
                            <div class="typeid">
                                <input v-if="firm==8" class="inp" type="text" v-model="property" ref="property" />
                            </div>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt>
                       <p>*</p>
                        <div class="short">
                            <em>资</em>
                            <div class="flex-1"></div>
                            <em>本</em>
                            <div class="flex-1"></div>
                            <em>类</em>
                            <div class="flex-1"></div>
                            <em>型：</em>
                        </div>
                    </dt>
                    <dd>
                        <div class="unify" :class="{curr:capital == 1}" @click="onCapital(1)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="capital!=1" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="capital==1" :src="$config.resource + 'xz.png'" alt="">
                            <p>有限责任公司</p>
                        </div>
                        <div class="unify" :class="{curr:capital == 2}" @click="onCapital(2)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="capital!=2" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="capital==2" :src="$config.resource + 'xz.png'" alt="">
                            <p>股份公司</p>
                        </div>
                        <div class="unify" :class="{curr:capital == 3}" @click="onCapital(3)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="capital!=3" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="capital==3" :src="$config.resource + 'xz.png'" alt="">
                            <p>上市公司</p>
                        </div>
                        <div class="unify" :class="{curr:capital == 4}" @click="onCapital(4)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="capital!=4" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="capital==4" :src="$config.resource + 'xz.png'" alt="">
                            <p>全资子公司</p>
                        </div>
                        <div class="unify" :class="{curr:capital == 5}" @click="onCapital(5)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="capital!=5" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="capital==5" :src="$config.resource + 'xz.png'" alt="">
                            <p>中外合资公司</p>
                        </div>
                        <div class="unify" :class="{curr:capital == 6}" @click="onCapital(6)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="capital!=6" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="capital==6" :src="$config.resource + 'xz.png'" alt="">
                            <p>外资公司</p>
                        </div>
                        <div class="unify" :class="{curr:capital == 7}" @click="onCapital(7)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="capital!=7" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="capital==7" :src="$config.resource + 'xz.png'" alt="">
                            <p>投资控股公司</p>
                        </div>
                        <div class="unify" :class="{curr:capital == 8}" @click="onCapital(8)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="capital!=8" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="capital==8" :src="$config.resource + 'xz.png'" alt="">
                            <p>其它</p>
                            <div class="typeid">
                                <input v-if="capital==8" class="inp" type="text" v-model="company_type" ref="company_type" />
                            </div>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        <p>*</p>
                        <div class="long">填写有母（子）公司或其他关联公司与利元亨合作的。如有，请列明名称或无：</div>
                    </dt>
                    <dd>
                        <div class="unify" :class="{curr:relevancy == 1}" @click="onRelevancy(1)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="relevancy!=1" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="relevancy==1" :src="$config.resource + 'xz.png'" alt="">
                            <p>无</p>
                        </div>
                        <div class="unify" :class="{curr:relevancy == 2}" @click="onRelevancy(2)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="relevancy!=2" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="relevancy==2" :src="$config.resource + 'xz.png'" alt="">
                            <p>有</p>
                            <div class="relation">
                                <input v-if="relevancy==2" class="inp" type="text" v-model="relevancy_name" ref="relevancy_name" />
                            </div>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        <p>*</p>
                        <div class="long">是否与利元亨董事、监事或高层有投资关联关系或直系近系亲属关系。如有，请列明名称或无：</div>
                    </dt>
                    <dd>
                        <div class="unify" :class="{curr:clan == 1}" @click="onClan(1)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="clan!=1" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="clan==1" :src="$config.resource + 'xz.png'" alt="">
                            <p>无</p>
                        </div>
                        <div class="unify" :class="{curr:clan == 2}" @click="onClan(2)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="clan!=2" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="clan==2" :src="$config.resource + 'xz.png'" alt="">
                            <p>有</p>
                            <div class="relation">
                                <input v-if="clan==2" class="inp" type="text" v-model="clan_name" ref="clan_name" />
                            </div>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        <p>*</p>
                        <div class="long">是否能按利元亨要求调整物料产品包装。如否，请说明原因：</div>
                    </dt>
                    <dd>
                        <div class="unify" :class="{curr:material == 1}" @click="onMaterial(1)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="material!=1" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="material==1" :src="$config.resource + 'xz.png'" alt="">
                            <p>是</p>
                        </div>
                        <div class="unify" :class="{curr:material == 2}" @click="onMaterial(2)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="material!=2" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="material==2" :src="$config.resource + 'xz.png'" alt="">
                            <p>否</p>
                            <div class="cause">
                                <input v-if="material==2" class="inp" type="text" v-model="pack" ref="pack" />
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
            <!-- 主要客户 -->
            <div class="alike">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>主要客户</p>
                </div>
                <ul>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">主要客户1：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="client_one" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">业务量占比：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="portfolio_one" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">合作产品：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="cooperate_one" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">主要客户2：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="client_two" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">业务量占比：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="portfolio_two" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">合作产品：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="cooperate_two" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">主要客户3：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="client_tri" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">业务量占比：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="portfolio_tri" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">合作产品：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="cooperate_tri" />
                        </div>
                    </li>
                </ul>
            </div>
            <!-- 按钮 -->
            <div class="btn_box">
                <div class="btn gray" v-if="isType!=2" @click="onSave">保存草稿</div>
                <div class="btn gray" @click="onBack">上一步</div>
                <div class="btn red" v-if="isType!=2" @click="onSubmit">下一步</div>
                <div class="btn red" v-if="isType==2" @click="toViewPage('/factory',{type:2})">下一步</div>
            </div>
        </div>
    </div>
</template>
<script>
    import store from '../vuex/store.js';
    export default {
        data(){
            return{
                user:'',// 用户信息
                isType:'',// 1.提交下一步 2.详情下一步 3.重新提交

                name:'',// 企业名称
                credit_code:'',// 统一社会信用代码
                establish:'',// 成立年份
                delegate:'',// 法人代表
                post:'',// 法人代表职务
                phone:'',// 法人联系电话
                abutment:'',// 业务对接人
                job:'',// 业务对接人职务
                telephone:'',// 业务对接人联系电话
                gmail:'',// 业务对接人E-mail
                run:'',// 经营范围
                trade:'',// 行业类别
                url:'',// 企业网址
                address:'',// 注册地址
                site:'',// 通信地址
                principal:'',// 注册资本
                total:'',// 资产总值
                saleroom:'',// 上年度销售额

                ratepaying:'',// 纳税人类别
                taxRate:'',// 税 率
                balance:'',// 结算方式
                closing:'',// 结算方式输入框
                receive:'',// 收付方式
                firm:'',// 企业性质
                property:'',// 企业性质输入框
                capital:'',// 资本类型
                company_type:'',// 资本类型输入框
                relevancy:'',// 关联公司
                relevancy_name:'',// 关联公司输入框
                clan:'',// 亲属关系
                clan_name:'',// 亲属关系输入框
                material:'',// 物料产品包装
                pack:'',// 物料产品包装输入框

                client_one:'',// 客户1
                portfolio_one:'',// 业务量占比
                cooperate_one:'',// 合作产品
                client_two:'',// 客户2
                portfolio_two:'',// 业务量占比
                cooperate_two:'',// 合作产品
                client_tri:'',// 客户3
                portfolio_tri:'',// 业务量占比
                cooperate_tri:'',// 合作产品
            }
        },
        store,
        methods: {
            //页面跳转
            toViewPage($path,$query) {
                this.$jump.toViewPage(this,$path,$query)
            },
            // 纳税人类别
            onRatepaying(ratepaying){
                this.ratepaying = ratepaying
            },
            // 税 率
            onTaxRate(taxRate){
               this.taxRate = taxRate
            },
            // 结算方式
            onBalance(balance){
                this.balance = balance 
                if(balance==4){
                    this.$nextTick((x)=>{   //正确写法
                        this.$refs.closing.focus()
                    })
                }
            },
            // 收付方式
            onReceive(receive){
                this.receive = receive 
            },
            // 企业性质
            onFirm(firm){
                this.firm = firm 
                if(firm==8){
                    this.$nextTick((x)=>{   //正确写法
                        this.$refs.property.focus()
                    })
                }
            },
            // 资本类型
            onCapital(capital){
                this.capital = capital 
                if(capital==8){
                    this.$nextTick((x)=>{   //正确写法
                        this.$refs.company_type.focus()
                    })
                }
            },
            // 关联公司
            onRelevancy(relevancy){
                this.relevancy = relevancy
                if(relevancy==2){
                    this.$nextTick((x)=>{   //正确写法
                        this.$refs.relevancy_name.focus()
                    })
                }
            },
            // 亲属关系
            onClan(clan){
                this.clan = clan 
                if(clan==2){
                    this.$nextTick((x)=>{   //正确写法
                        this.$refs.clan_name.focus()
                    })
                }
            },
            // 亲属关系
            onMaterial(material){
                this.material = material
                if(material==2){
                    this.$nextTick((x)=>{   //正确写法
                        this.$refs.pack.focus()
                    })
                }
            },
            // 保存草稿
            onSave(){
                const that = this
                let settle_type = '';// 结算方式
                if(that.balance==4){
                    settle_type = that.closing
                }else{
                    settle_type = that.balance
                }
                let company_nature = '';// 企业性质
                if(that.firm==8){
                    company_nature = that.property
                }else{
                    company_nature = that.firm
                }
                let company_type = '';// 资本类型
                if(that.capital==8){
                    company_type = that.company_type
                }else{
                    company_type = that.capital
                }
                let is_other = '';// 关联公司
                if(that.relevancy==2){
                    is_other = that.relevancy_name
                }else{
                    is_other = 0
                }
                let is_family = '';// 亲属关系
                if(that.clan==2){
                    is_family = that.clan_name
                }else{
                    is_family = 0
                }
                let adjust = '';// 物料产品包装
                if(that.material==2){
                    adjust = that.pack
                }else{
                    adjust = 1
                }
                that.$request({
                    that: that,
                    api: that.$api.editinfo,
                    data: {
                        company_name:that.name,// 企业名称
                        code:that.credit_code,// 统一社会信用代码
                        company_year:that.establish,// 成立年份
                        legal_person:that.delegate,// 法人代表
                        legal_pos:that.post,// 法人代表职务
                        legal_phone:that.phone,// 法人联系电话
                        service_person:that.abutment,// 业务对接人
                        service_position:that.job,// 业务对接人职务
                        service_phone:that.telephone,// 业务对接人联系电话
                        service_email:that.gmail,// 业务对接人E-mail
                        scope:that.run,// 经营范围
                        category:that.trade,// 行业类别
                        company_url:that.url,// 企业网址
                        register_add:that.address,// 注册地址
                        company_address:that.site,// 通信地址
                        money:that.principal,// 注册资本
                        company_money:that.total,// 资产总值
                        year_sales:that.saleroom,// 上年度销售额
                        taxpayers:that.ratepaying,// 纳税人类别
                        rate:that.taxRate,// 税 率
                        settle_type:settle_type,// 结算方式
                        pay_method:that.receive,// 收付方式
                        company_nature:company_nature,// 企业性质
                        company_type:company_type,// 资本类型
                        is_other:is_other,// 关联公司
                        is_family:is_family,// 亲属关系
                        adjust:adjust,// 物料产品包装
                        clients_name:that.client_one,// 客户1
                        client_share:that.portfolio_one,// 业务量占比1
                        provide:that.cooperate_one,// 合作产品1
                        s_clients_name:that.client_two,// 客户2
                        s_client_share:that.portfolio_two,// 业务量占比2
                        s_provide:that.cooperate_two,// 合作产品2
                        t_clients_name:that.client_tri,// 客户3
                        t_client_share:that.portfolio_tri,// 业务量占比3
                        t_provide:that.cooperate_tri,// 合作产品3
                        type:2,
                    },
                    success(res) {
                        that.$dialog.toast({
                            mes: res.msg,
                            timeout: 1500,
                            icon: 'success',
                        })
                    }
                })
            },
            // 上一步
            onBack(){
                this.$router.go(-1);
            },
            // 提交下一步
            onSubmit(){
                const that = this
                let settle_type = '';// 结算方式
                if(that.balance==4){
                    settle_type = that.closing
                }else{
                    settle_type = that.balance
                }
                let company_nature = '';// 企业性质
                if(that.firm==8){
                    company_nature = that.property
                }else{
                    company_nature = that.firm
                }
                let company_type = '';// 资本类型
                if(that.capital==8){
                    company_type = that.company_type
                }else{
                    company_type = that.capital
                }
                let is_other = '';// 关联公司
                if(that.relevancy==2){
                    is_other = that.relevancy_name
                }else{
                    is_other = 0
                }
                let is_family = '';// 亲属关系
                if(that.clan==2){
                    is_family = that.clan_name
                }else{
                    is_family = 0
                }
                let adjust = '';// 物料产品包装
                if(that.material==2){
                    adjust = that.pack
                }else{
                    adjust = 1
                }
                that.$request({
                    that: that,
                    api: that.$api.editinfo,
                    data: {
                        company_name:that.name,// 企业名称
                        code:that.credit_code,// 统一社会信用代码
                        company_year:that.establish,// 成立年份
                        legal_person:that.delegate,// 法人代表
                        legal_pos:that.post,// 法人代表职务
                        legal_phone:that.phone,// 法人联系电话
                        service_person:that.abutment,// 业务对接人
                        service_position:that.job,// 业务对接人职务
                        service_phone:that.telephone,// 业务对接人联系电话
                        service_email:that.gmail,// 业务对接人E-mail
                        scope:that.run,// 经营范围
                        category:that.trade,// 行业类别
                        company_url:that.url,// 企业网址
                        register_add:that.address,// 注册地址
                        company_address:that.site,// 通信地址
                        money:that.principal,// 注册资本
                        company_money:that.total,// 资产总值
                        year_sales:that.saleroom,// 上年度销售额
                        taxpayers:that.ratepaying,// 纳税人类别
                        rate:that.taxRate,// 税 率
                        settle_type:settle_type,// 结算方式
                        pay_method:that.receive,// 收付方式
                        company_nature:company_nature,// 企业性质
                        company_type:company_type,// 资本类型
                        is_other:is_other,// 关联公司
                        is_family:is_family,// 亲属关系
                        adjust:adjust,// 物料产品包装
                        clients_name:that.client_one,// 客户1
                        client_share:that.portfolio_one,// 业务量占比1
                        provide:that.cooperate_one,// 合作产品1
                        s_clients_name:that.client_two,// 客户2
                        s_client_share:that.portfolio_two,// 业务量占比2
                        s_provide:that.cooperate_two,// 合作产品2
                        t_clients_name:that.client_tri,// 客户3
                        t_client_share:that.portfolio_tri,// 业务量占比3
                        t_provide:that.cooperate_tri,// 合作产品3
                        type:1,
                    },
                    success(res) {
                        that.$dialog.toast({
                            mes: '提交成功',
                            timeout: 1500,
                            icon: 'success',
                            callback(){
                                that.$router.push({ path: '/factory',query:{type:that.isType} })
                            }
                        })
                    }
                })
            },
            // 获取保存草稿
            getDraft(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.firstTrialDraft,
                    data: {},
                    success(res) {
                        that.name = res.data.company_name // 企业名称
                        that.credit_code = res.data.code // 统一社会信用代码
                        if(res.data.company_year!=null&&res.data.company_year!=''&&res.data.company_year!=0){// 成立年份 
                            that.establish = res.data.company_year 
                        }
                        that.delegate = res.data.legal_person // 法人代表
                        that.post = res.data.legal_pos //法人代表职务 
                        that.phone = res.data.legal_phone // 法人联系电话
                        that.abutment = res.data.service_person // 业务对接人
                        that.job = res.data.service_position // 业务对接人职务
                        that.telephone = res.data.service_phone // 业务对接人联系电话
                        that.gmail = res.data.service_email // 业务对接人E-mail
                        that.run = res.data.scope // 经营范围
                        that.trade = res.data.category // 行业类别
                        that.url = res.data.company_url // 企业网址
                        that.address = res.data.register_add // 注册地址
                        that.site = res.data.company_address // 通信地址
                        that.principal = res.data.money // 注册资本
                        that.total = res.data.company_money // 资产总值
                        that.saleroom = res.data.year_sales // 上年度销售额

                        that.ratepaying = res.data.taxpayers // 纳税人类别
                        that.taxRate = res.data.rate // 税 率
                        if(res.data.settle_type!=1&&res.data.settle_type!=2&&res.data.settle_type!=3&&res.data.settle_type!=null&&res.data.settle_type!=''){// 结算方式
                            that.balance = 4
                            that.closing = res.data.settle_type
                        }else{
                            that.balance = res.data.settle_type
                        }
                        that.receive = res.data.pay_method // 收付方式
                        if(res.data.company_nature!=1&&res.data.company_nature!=2&&res.data.company_nature!=3&&res.data.company_nature!=4&&res.data.company_nature!=5&&res.data.company_nature!=6&&res.data.company_nature!=7&&res.data.company_nature!=null&&res.data.company_nature!=''){//企业性质
                            that.firm = 8
                            that.property = res.data.company_nature
                        }else{
                            that.firm = res.data.company_nature
                        }
                        if(res.data.company_type!=1&&res.data.company_type!=2&&res.data.company_type!=3&&res.data.company_type!=4&&res.data.company_type!=5&&res.data.company_type!=6&&res.data.company_type!=7&&res.data.company_type!=null&&res.data.company_type!=''){//资本类型
                            that.capital = 8
                            that.company_type = res.data.company_type
                        }else{
                            that.capital = res.data.company_type
                        }
                        if(res.data.is_other!=null&&res.data.is_other!=''){// 关联公司
                            if(res.data.is_other==0){
                                that.relevancy = 1
                            }else{
                                that.relevancy = 2
                                that.relevancy_name = res.data.is_other
                            }
                        }
                        if(res.data.is_family!=null&&res.data.is_family!=''){// 亲属关系
                            if(res.data.is_family==0){
                                that.clan = 1
                            }else{
                                that.clan = 2
                                that.clan_name = res.data.is_family
                            }
                        }
                        if(res.data.adjust!=null&&res.data.adjust!=''){// 物料产品包装
                            if(res.data.adjust==1){
                                that.material = 1
                            }else{
                                that.material = 2
                                that.pack = res.data.adjust 
                            }
                        }

                        that.client_one = res.data.clients_name // 客户1
                        that.portfolio_one = res.data.client_share // 业务量占比1
                        that.cooperate_one =  res.data.provide // 合作产品1

                        that.client_two = res.data.s_clients_name // 客户2
                        that.portfolio_two = res.data.s_client_share // 业务量占比2
                        that.cooperate_two =  res.data.s_provide // 合作产品2

                        that.client_tri = res.data.t_clients_name // 客户3
                        that.portfolio_tri = res.data.t_client_share // 业务量占比3
                        that.cooperate_tri =  res.data.t_provide // 合作产品3
                        
                    }
                }) 
            },
            // 获取审批后详情
            getDetails(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.particulars,
                    data: {},
                    success(res) {
                        that.name = res.data.company_name // 企业名称
                        that.credit_code = res.data.code // 统一社会信用代码
                        if(res.data.company_year!=null&&res.data.company_year!=''&&res.data.company_year!=0){// 成立年份 
                            that.establish = res.data.company_year 
                        }
                        that.delegate = res.data.legal_person // 法人代表
                        that.post = res.data.legal_pos //法人代表职务 
                        that.phone = res.data.legal_phone // 法人联系电话
                        that.abutment = res.data.service_person // 业务对接人
                        that.job = res.data.service_position // 业务对接人职务
                        that.telephone = res.data.service_phone // 业务对接人联系电话
                        that.gmail = res.data.service_email // 业务对接人E-mail
                        that.run = res.data.scope // 经营范围
                        that.trade = res.data.category // 行业类别
                        that.url = res.data.company_url // 企业网址
                        that.address = res.data.register_add // 注册地址
                        that.site = res.data.company_address // 通信地址
                        that.principal = res.data.money // 注册资本
                        that.total = res.data.company_money // 资产总值
                        that.saleroom = res.data.year_sales // 上年度销售额

                        that.ratepaying = res.data.taxpayers // 纳税人类别
                        that.taxRate = res.data.rate // 税 率
                        if(res.data.settle_type!=1&&res.data.settle_type!=2&&res.data.settle_type!=3&&res.data.settle_type!=null&&res.data.settle_type!=''){// 结算方式
                            that.balance = 4
                            that.closing = res.data.settle_type
                        }else{
                            that.balance = res.data.settle_type
                        }
                        that.receive = res.data.pay_method // 收付方式
                        if(res.data.company_nature!=1&&res.data.company_nature!=2&&res.data.company_nature!=3&&res.data.company_nature!=4&&res.data.company_nature!=5&&res.data.company_nature!=6&&res.data.company_nature!=7&&res.data.company_nature!=null&&res.data.company_nature!=''){//企业性质
                            that.firm = 8
                            that.property = res.data.company_nature
                        }else{
                            that.firm = res.data.company_nature
                        }
                        if(res.data.company_type!=1&&res.data.company_type!=2&&res.data.company_type!=3&&res.data.company_type!=4&&res.data.company_type!=5&&res.data.company_type!=6&&res.data.company_type!=7&&res.data.company_type!=null&&res.data.company_type!=''){//资本类型
                            that.capital = 8
                            that.company_type = res.data.company_type
                        }else{
                            that.capital = res.data.company_type
                        }
                        if(res.data.is_other!=null&&res.data.is_other!=''){// 关联公司
                            if(res.data.is_other==0){
                                that.relevancy = 1
                            }else{
                                that.relevancy = 2
                                that.relevancy_name = res.data.is_other
                            }
                        }
                        if(res.data.is_family!=null&&res.data.is_family!=''){// 亲属关系
                            if(res.data.is_family==0){
                                that.clan = 1
                            }else{
                                that.clan = 2
                                that.clan_name = res.data.is_family
                            }
                        }
                        if(res.data.adjust!=null&&res.data.adjust!=''){// 物料产品包装
                            if(res.data.adjust==1){
                                that.material = 1
                            }else{
                                that.material = 2
                                that.pack = res.data.adjust 
                            }
                        }
                        
                        that.client_one = res.data.clients_name // 客户1
                        that.portfolio_one = res.data.client_share // 业务量占比1
                        that.cooperate_one =  res.data.provide // 合作产品1

                        that.client_two = res.data.s_clients_name // 客户2
                        that.portfolio_two = res.data.s_client_share // 业务量占比2
                        that.cooperate_two =  res.data.s_provide // 合作产品2

                        that.client_tri = res.data.t_clients_name // 客户3
                        that.portfolio_tri = res.data.t_client_share // 业务量占比3
                        that.cooperate_tri =  res.data.t_provide // 合作产品3
                    }
                }) 
            },
            // 用户信息
            getUser(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.consumer,
                    data: {},
                    success(res) {
                       that.user = res.data
                    }
                })
            },
            // 退出
            onQuit(){
                const that = this
                //存储用户登录凭证
                that.$storage.remove('accesstoken')

                //登录成功发起页面跳转
                that.$dialog.toast({
                    mes: '退出登录成功',
                    timeout: 2000,
                    icon: 'success',
                    callback(){
                        that.$router.push({ path: '/logIn' })
                    }
                })
            },
        },
        mounted() {
            const that = this
            that.$store.commit('EditPageData',this.PageData)
            that.getUser()// 用户信息
            that.isType = that.$route.query.type
            if(that.$route.query.type==2){
                that.getDetails()// 获取审批后详情
            }else{
                that.getDraft()// 获取保存草稿
            }
        },
        components:{
            
        },
    }
</script>


// WEBPACK FOOTER //
// src/page/enterprise.vue